document.addEventListener("DOMContentLoaded", function () {
  const typewriterWord = document.getElementById("typewriter-word");
  const words = ["Pickles", "Chutneys", "Pastes"]; // Add words to cycle through
  let wordIndex = 0;
  let letterIndex = 0;

  function typeWord() {
    const word = words[wordIndex];
    const currentWord = typewriterWord.textContent;
    if (letterIndex < word.length) {
      typewriterWord.textContent = currentWord + word[letterIndex];
      letterIndex++;
      setTimeout(typeWord, 100); // Adjust typing speed here
    } else {
      setTimeout(eraseWord, 1000); // Adjust pause before erasing here
    }
  }

  function eraseWord() {
    const currentWord = typewriterWord.textContent;
    if (currentWord.length > 0) {
      typewriterWord.textContent = currentWord.slice(0, -1);
      setTimeout(eraseWord, 50); // Adjust erasing speed here
    } else {
      wordIndex = (wordIndex + 1) % words.length;
      letterIndex = 0; // Reset letterIndex to 0
      setTimeout(typeWord, 1000); // Adjust pause before typing the next word here
    }
  }

  typeWord(); // Start the typewriter effect
});
